import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ISchemaDataDTO } from 'dto/ISchemaDataDTO';
import { IFlowStartupReferenceDTO } from 'dto/IFlowStartupReferenceDTO';

@Component({
  name: 'NodeFormMixin',
})
export default class NodeFormMixin extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  value: any;

  @Prop({
    type: Object,
    required: false,
  })
  type: ISchemaDataDTO;

  data: {
    title: string;
    description: string;
    action: any;
    labels: { label: string; description: string; default?: string }[];
  } = {
    title: null,
    description: null,
    action: {},
    labels: [],
  };

  @Prop({
    type: Array,
    required: true,
  })
  startupTypes: IFlowStartupReferenceDTO[];

  created() {
    this.data = {
      action: this.initializeActionData(this.value.actionData ? { ...this.value.actionData } : {}),
      title: this.value.title,
      description: this.value.description,
      labels: this.initializeLabels([...(this.value.labels || [])]),
    };
  }

  initializeActionData(action) {
    return action;
  }

  @Watch('value')
  onValueChanged(value, prevVal) {
    this.data = {
      action: value.actionData ? { ...this.value.actionData } : {},
      title: value.title,
      description: value.description,
      labels: this.initializeLabels([...(value.labels || [])]),
    };
  }

  handleClose() {
    this.$emit('abort');
  }

  handleDeleteNode() {
    this.$emit('delete', this.value);
  }

  handleSave() {
    this.$emit('input', {
      ...this.value,
      title: this.data.title,
      description: this.data.description,
      actionData: {
        ...this.data.action,
      },
      labels: this.initializeLabels([...(this.data.labels || [])]),
    });
  }

  initializeLabels(labels: { label: string; description: string; default?: string }[]): { label: string; description: string; default?: string }[] {
    for (let i = 0; i < this.type.endpoints.length; i += 1) {
      if (this.type.endpoints[i] === 1) {
        if (!labels[i]) {
          labels[i] = { description: null, label: null };
        }
        if (!labels[i].default) {
          labels[i].default = this.type.endpointLabels[i];
        }
      } else if (labels[i]) {
          labels[i] = null;
        }
    }
    return labels;
  }
}
